import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { AccountingService } from '../accounting.service';
import { ModalCancelComponent } from '../modal-cancel/modal-cancel.component';
import { ModalPrintComponent } from '../modal-print/modal-print.component';

@Component({
  selector: 'app-create-quotation',
  templateUrl: './create-quotation.component.html',
  styleUrls: ['./create-quotation.component.scss']
})
export class CreateQuotationComponent implements OnInit {

  isLoading: boolean = false;
  isEdit: boolean = false;
  quotationForm: FormGroup;

  tax: boolean = false;
  vat: boolean = false;

  total: number = 0;
  discount: number = 0;
  priceWithoutVat: number = 0;
  taxPrice: number = 0;
  vatPrice: number = 0;
  totalNetPrice: number = 0;

  id: string;
  version: any = [];
  ver: number = 0;
  currentVer: number;
  date: any;

  bank = [];
  bankSelect: any;
  quotationDetail: any;

  printDetail: any;
  isPrint: boolean = false;
  canPrint: boolean = false;
  hasChange: boolean = false;
  printData: any;

  column = [
    { header: 'เลขที่', class: 'col-1' },
    { header: 'รายการ', class: 'col-4' },
    { header: 'จำนวน', class: 'col-1' },
    { header: 'ราคาต่อหน่วย', class: 'col-2' },
    { header: 'ส่วนลด', class: 'col-1' },
    { header: 'จำนวนเงิน', class: 'col-2' },
    { header: '', class: 'col-1' },
  ];
  formatterPrice = (value: number): string =>
    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  constructor(
    private fb: FormBuilder,
    private gobalFunctionService: GobalFunctionService,
    public matDialog: MatDialog,
    private accountService: AccountingService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));

    if (this.isEdit) {
      this.id = new URL(location.href).searchParams.get('id');
      this.ver = parseInt(new URL(location.href).searchParams.get('version'));
      this.currentVer = this.ver;
      for (let i = 1; i <= this.currentVer; i++) {
        this.version.push(i);
      }

      this.gobalFunctionService.setTitle(`ใบเสนอราคา ${this.id}`);
    } else {
      this.gobalFunctionService.setTitle('สร้างใบเสนอราคา');
    }
    this.getBankAccount();
  }

  getBankAccount() {
    this.accountService.getActiveAccount().pipe(
      map(res => {
        if (res.success) {
          res.result.forEach(e => {
            this.bank.push({
              ACCOUNTING_ID: e.ACCOUNTING_ID,
              ACCOUNTING_NAME: e.ACCOUNTING_NAME
            })
          })
          this.getDetailQuotation(this.id, this.ver);
        }
      }),
      catchError(err => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  getDetailQuotation(id, ver) {
    this.isLoading = true;
    if (this.isEdit || this.isPrint) {

      this.accountService.getDetailQuotation(id, ver).pipe(
        map(q => {
          // console.log(q.result);
          this.quotationDetail = q.result;

          this.bankSelect = {
            ACCOUNTING_ID: this.quotationDetail.ACCOUNTING_ID,
            ACCOUNTING_NAME: this.quotationDetail.ACCOUNTING_NAME
          }
          this.date = [this.quotationDetail.QUOTATION_START, this.quotationDetail.QUOTATION_END];

          this.quotationForm = this.fb.group({
            accountId: [this.quotationDetail.ACCOUNTING_ID, Validators.required],
            accountName: [this.quotationDetail.ACCOUNTING_NAME, Validators.required],
            name: [this.quotationDetail.CUSTOMER_NAME, Validators.required],
            note: [this.quotationDetail.REMARK],
            detail: [this.quotationDetail.CUSTOMER_DETAIL, Validators.required],
            title: [this.quotationDetail.TITLE, Validators.required],
            taxId: [this.quotationDetail.TAX_NO, [Validators.required, Validators.pattern("([0-9]{13}$)")]],
            date: [this.quotationDetail.QUOTATION_START, Validators.required],
            dateEnd: [this.quotationDetail.QUOTATION_END, Validators.required],
            includeVat: [this.quotationDetail.INCLUDE_VAT === 1 ? true : false],
            lists: this.fb.array([])
          });
          this.addGroup(true);
          // console.log(this.quotationForm);
          this.onCreateGroupFormValueChange();

          if (this.isPrint) {
            this.printPdf(this.printData);
          }

        }),
        catchError((err) => {
          alert(err.error.message);
          this.router.navigate(['/']);
          return of(null);
        })
      ).subscribe();

    } else {
      // if (this.isPrint) {
      //   // console.log(';;;;;;');


      // } else {
      this.quotationForm = this.fb.group({
        accountId: ['', Validators.required],
        accountName: ['', Validators.required],
        name: ['', Validators.required],
        note: [''],
        detail: ['', Validators.required],
        title: ['', Validators.required],
        taxId: ['', [Validators.required, Validators.pattern("([0-9]{13}$)")]],
        date: ['', Validators.required],
        dateEnd: ['', Validators.required],
        includeVat: [false],
        lists: this.fb.array([])
      });
      if (this.quotationForm.value.lists.length === 0) { this.addGroup(false); }
      // }

    }
    setTimeout(() => {
      this.isLoading = false;
    }, 500)

  }

  selectVersion(v) {
    this.ver = v;
    // console.log(this.ver);
    this.getDetailQuotation(this.id, this.ver);

  }

  addGroup(isEdit: boolean) {
    if (isEdit) {
      this.quotationDetail.quoDetail.forEach(e => {
        (<FormArray>this.quotationForm.get("lists")).push(this.fb.group({
          list: [e.DESCRIPTION, [Validators.required]],
          number: [e.QTY, [Validators.required]],
          unitPrice: [e.UNIT_PRICE, [Validators.required]],
          discount: [e.DISCOUNT, [Validators.required]],
          totalWithoutDiscount: [e.UNIT_PRICE * e.QTY, Validators.required],
          total: [e.TOTAL],
        }));
      });
      this.getSummary(this.quotationFormArray);
      if (this.quotationDetail.INCLUDE_VAT === 1) {
        this.vat = true;
        this.calNetPrice();
      }
    } else {
      (<FormArray>this.quotationForm.get("lists")).push(this.fb.group({
        list: ['', [Validators.required]],
        number: [0, [Validators.required]],
        unitPrice: [0, [Validators.required]],
        discount: [0, [Validators.required]],
        totalWithoutDiscount: [0, Validators.required],
        total: [0],
      }));
    }
  }

  get quotationFormArray(): FormArray {
    return this.quotationForm.get('lists') as FormArray;
  }

  removeGroup(i, form) {
    (<FormArray>form.get("lists")).removeAt(i);

    // this.getTotal(this.quotationFormArray, i);
    this.getSummary(this.quotationFormArray);
  }

  getClass() {
    if (!this.quotationDetail) { return ''; }
    if (this.quotationDetail.STATUS === 'Done') { return 'disable-display'; }
    if (this.quotationDetail.STATUS === 'Cancel') { return 'disable-display'; }
    if (this.quotationDetail.STATUS === 'Partial') { return 'disable-display'; }
    if (this.ver < this.currentVer) { return 'disable-display'; }
  }


  onCreateGroupFormValueChange() {
    const initialValue = this.quotationForm.value;
    this.quotationForm.valueChanges.subscribe(value => {

      this.hasChange = Object.keys(initialValue).some(key => this.quotationForm.value[key] !== initialValue[key]);
    });

    // console.log(this.hasChange);

  }

  selectBank(e, form) {
    // console.log(e);

    form.patchValue({
      accountId: e.ACCOUNTING_ID,
      accountName: e.ACCOUNTING_NAME
    });
    form.get('accountId').updateValueAndValidity();
    form.get('accountName').updateValueAndValidity();

    // console.log(form);

  }

  selectDate(e, form) {
    // console.log(e[0]);
    // console.log(e[1]);

    form.patchValue({
      date: e[0],
      dateEnd: e[1]
    });
    form.get('date').updateValueAndValidity();
    form.get('dateEnd').updateValueAndValidity();
  }

  getTotal(form, i) {
    let number = form.value[i].number;
    let unitPrice = form.value[i].unitPrice;
    let discount = form.value[i].discount;
    let total = (unitPrice * number) - discount;
    let totalWithoutDiscount = unitPrice * number;

    form.at(i).patchValue({
      total: total,
      totalWithoutDiscount: totalWithoutDiscount
    })
    // console.log(form)
  }

  getSummary(form) {
    let priceWithoutVat = 0;
    let unitPrice = 0;
    let discount = 0;
    let totalWithoutDiscount = 0;
    let vatPrice = 0;
    let totalNetPrice = 0;

    form.value.forEach((e, i) => {
      unitPrice = unitPrice + e.unitPrice;
      discount = discount + e.discount;
      totalWithoutDiscount = totalWithoutDiscount + e.totalWithoutDiscount;
      priceWithoutVat = priceWithoutVat + e.total;
    });

    this.total = totalWithoutDiscount;
    this.discount = discount
    this.priceWithoutVat = priceWithoutVat;

    if (this.vat) {
      vatPrice = (priceWithoutVat * 7) / 100;
      totalNetPrice = priceWithoutVat + vatPrice;

    } else {
      totalNetPrice = priceWithoutVat;
      vatPrice = 0;
    }

    this.totalNetPrice = totalNetPrice;
    this.vatPrice = vatPrice;

  }

  calNetPrice() {
    this.quotationForm.patchValue({
      includeVat: this.vat,
    });
    this.quotationForm.get('includeVat').updateValueAndValidity();

    if (this.vat) {
      this.vatPrice = (this.priceWithoutVat * 7) / 100;
      this.totalNetPrice = this.totalNetPrice + this.vatPrice;
    } else {
      this.totalNetPrice = this.priceWithoutVat;
      this.vatPrice = 0;
    }
  }

  detectNumber(e, formcontrol) {
    // console.log(e);
    if (e < 0) {
      // this.evidenceForm.controls['TRANFER_HR'].setValue(0);
      formcontrol.setValue(0);
      // formcontrol.setErrors({'incorrect': true});
    }
  }

  save(form) {
    this.isLoading = true;

    let items = [];
    form.lists.forEach((e, i) => {
      items.push({
        ITEM_NUM: i + 1,
        DESCRIPTION: e.list,
        QTY: e.number,
        UNIT_PRICE: e.unitPrice,
        DISCOUNT: e.discount,
        TOTAL: e.total
      })
    });

    let body = {
      CUSTOMER_NAME: form.name,
      CUSTOMER_DETAIL: form.detail,
      TITLE: form.title,
      TAX_NO: form.taxId,
      QUOTATION_START: form.date,
      QUOTATION_END: form.dateEnd,
      ITEMS: items,
      REMARK: form.note,
      INCLUDE_VAT: form.includeVat,
      ACCOUNTING_ID: form.accountId,
      ACCOUNTING_NAME: form.accountName,
    };

    // console.log(body)

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    // dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'บันทึกใบเสนอราคา',
      actionBtnText: 'บันทึก',
      cancleBtnText: 'ยกเลิก',
      description: `<h5 class="m-4">ใบเสนอราคานี้จะถูกบันทึกเป็นเวอร์ชันที่ ${this.ver + 1}</h5>`
    }
    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.accountService.createQuotation(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกใบเสนอราคาสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      if (!this.isPrint) {
                        this.isLoading = false;
                        window.open('accounting?type=quotation', '_self');
                        // window.opener.location.reload();
                        // setTimeout(() => {
                        //   window.close();

                        // }, 100);
                      } else {
                        this.ver = res1.result.QUOTATION_VERSION;
                        this.id = res1.result.QUOTATION_NO;
                        this.getDetailQuotation(this.id, this.ver);
                      }
                    }
                  })
                )
              }

            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError(err => {
        this.isLoading = false;
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(false);
      })
    ).subscribe();

  }

  updateQuotation(form) {
    this.isLoading = true;
    let items = [];
    form.lists.forEach((e, i) => {
      items.push({
        ITEM_NUM: i + 1,
        DESCRIPTION: e.list,
        QTY: e.number,
        UNIT_PRICE: e.unitPrice,
        DISCOUNT: e.discount,
        TOTAL: e.total
      })
    });

    let body = {
      QUOTATION_NO: this.quotationDetail.QUOTATION_NO,
      CUSTOMER_NAME: form.name,
      CUSTOMER_DETAIL: form.detail,
      TITLE: form.title,
      TAX_NO: form.taxId,
      QUOTATION_START: form.date,
      QUOTATION_END: form.dateEnd,
      ITEMS: items,
      REMARK: form.note,
      INCLUDE_VAT: form.includeVat,
      ACCOUNTING_ID: form.accountId,
      ACCOUNTING_NAME: form.accountName,
    };

    // console.log(body)

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    // dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'บันทึกใบเสนอราคา',
      actionBtnText: 'บันทึก',
      cancleBtnText: 'ยกเลิก',
      description: `<h5 class="m-4">ใบเสนอราคานี้จะถูกบันทึกเป็นเวอร์ชันที่ ${this.ver + 1}</h5>`
    }
    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.accountService.updateQuotation(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกใบเสร็จสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      if (!this.isPrint) {
                        // console.log('395');
                        // console.log(this.isPrint);

                        this.isLoading = false;
                        window.open('accounting?type=quotation', '_self');
                        // window.opener.location.reload();
                        // setTimeout(() => {
                        //   window.close();
                        //   // console.log('false แล้ววว');

                        // }, 100);
                      } else {
                        // console.log('ถูก');
                        this.ver = res1.result.QUOTATION_VERSION;
                        this.id = res1.result.QUOTATION_NO;
                        this.getDetailQuotation(this.id, this.ver);
                      }
                    }
                  })
                )
              }

            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError(err => {
        this.isLoading = false;
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(false);
      })
    ).subscribe();
  }

  cancel(id, ver) {
    let body;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      id: id,
      type: 'quotation'
    }
    const modal = this.matDialog.open(ModalCancelComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          // console.log(res);
          body = {
            QUOTATION_NO: id,
            QUOTATION_VERSION: ver,
            CANCEL_REMARK: res.value,
          }

          return this.accountService.cancelQuotation(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ยกเลิกใบเสนอราคาสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      this.isLoading = false;
                      window.open('accounting?type=quotation', '_self');
                      // window.opener.location.reload();
                      // setTimeout(() => {
                      //   window.close()
                      // }, 100);
                    }
                  })
                )
              }
            })
          )
        } else {
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/'])
        return of(false);
      })
    ).subscribe();
  }

  print(form) {
    this.isLoading = true;
    // console.log(this.ver);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '400px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      type: 'quotation',
    };

    const modal = this.matDialog.open(ModalPrintComponent, dialogConfig);
    return modal.afterClosed().pipe(
      map(print => {
        if (print.status) {
          this.isPrint = true;
          this.printData = print;

          if (!this.isEdit) {
            this.save(form);
          } else {
            if (this.quotationDetail.STATUS === 'Done' || !this.hasChange) {
              this.printPdf(this.printData);
            } else {
              this.updateQuotation(form);
            }
          }

        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError(err => {
        this.isLoading = false;
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  printPdf(print) {
    console.log(print)
    let total = 0,
      discount = 0,
      priceWithoutVat = 0,
      vatPrice = 0,
      totalNetPrice = 0;

    this.quotationDetail.quoDetail.forEach(e => {
      total = total + (e.TOTAL + e.DISCOUNT);
      discount = discount + e.DISCOUNT;
      priceWithoutVat = priceWithoutVat + e.TOTAL;
    });

    if (this.vat) {
      vatPrice = (priceWithoutVat * 7) / 100;
      totalNetPrice = priceWithoutVat + vatPrice;

    } else {
      totalNetPrice = priceWithoutVat;
      vatPrice = 0;
    }

    let data = {
      detail: this.quotationDetail,
      price: {
        total: total,
        discount: discount,
        priceWithoutVat: priceWithoutVat,
        vatPrice: vatPrice,
        totalNetPrice: totalNetPrice,
      },
      type: 'quotation',
      note: this.quotationForm.value.note
    }
    this.printDetail = {
      printType: print.printType,
      titleType: print.titleType,
      printData: data,
    }
    this.canPrint = true;

    setTimeout(() => {
      this.isPrint = false;
      this.canPrint = false;
      this.isLoading = false;

      if ((this.isEdit && this.hasChange) || !this.isEdit) {
        window.open(`/accounting/create-quotation?isEdit=true&id=${this.id}&version=${this.ver}`, '_self');
      }

    }, 1000);
    // console.log(print);
  }

  compareFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.ACCOUNTING_ID === i2.ACCOUNTING_ID : i1 === i2;
  }

  close() {
    window.close();
  }


}
